import { makeStyles } from 'tss-react/mui';
import MaterialLink from '../material-link';
import { eventPath } from '../../utils/slugify';
import type { Event } from '../../types/Event';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    marginTop: theme.spacing(1),
  },
  link: {
    color: '#000',
    fontWeight: 'bold',
  },
}));

type Props = {
  event?: Event;
};

const AttendeesSummary = ({ event }: Props) => {
  const { memberSummary } = event;
  const { classes } = useStyles();

  if (!memberSummary) {
    return null;
  }

  const summaryText = `${memberSummary.GOING.count} Going – ${
    memberSummary.INTERESTED.count} Interested`;
  return (
    <div className={classes.wrapper}>
      {event.permissions.attendeesViewable ? (
        <MaterialLink
          href={`${eventPath(event.id, event.name)}/attendees`}
          className={classes.link}
        >
          {summaryText}
        </MaterialLink>
      ) : summaryText}
    </div>
  )
};

export default AttendeesSummary;
